//
//
//
//
//
//
//
//
//
//
//
//

import { getAiAgentFlowUrl } from '@/utils/wujieConfig'
export default {
  components: {},
  data() {
    return {
      iframeSrc: getAiAgentFlowUrl(), // 替换为你想要加载的网页
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    onIframeLoad() {
      console.log('IFrame 加载完成');
    },
  },
};
